(function loginDirectiveDefinition() {

    'use strict';

    /*
     * Esta directiva permite mostrar una pantalla de login al clickear en el elemento en que se coloca.
     */
    angular.module('Login')
        .directive('crLogin', [
            '$http', '$compile', '$templateCache', '$injector', 'login',
            function ($http, $compile, $templateCache, $injector, login) {
                return {
                    restrict: 'A',
                    scope: {
                        onLogin: '&'
                    },
                    link: function loginDirectiveLink($scope, element, attrs) {

                        var loginControl = null;

                        function setLoginPosition() {

                            var offset = element.offset();
                            var right = ($(window).width() - offset.left);

                            var left = $(window).width() - right - loginControl.width();

                            if (left > 0) {
                                loginControl.css({
                                    right: right,
                                    top: offset.top,
                                    left: left,
                                    position: 'fixed'
                                });
                            } else {
                                loginControl.css({
                                    right: 0,
                                    left: 0,
                                    top: 0,
                                    position: 'fixed'
                                });
                            }
                        }
						
						function hide() {
                            loginControl.hide();
                            $(document).off('click', $scope.close);
                            $(window).off('resize', $scope.close);
                        }

                        var promise = $http.get(login.templatesUrl + 'login.html', { cache: $templateCache }).
                            then(function (response) {

                                loginControl = $(response.data);

                                $scope.useRegister = $scope.$eval(attrs.useRegister);
                                $scope.disableExternalLogin = $scope.$eval(attrs.disableExternalLogin);

                                $compile(loginControl)($scope);

                                loginControl.hide();

                                loginControl.appendTo('body');

                                loginControl.on('click', function (evt) {
                                    evt.stopImmediatePropagation();
                                });
                            });

                        element.on("click", function () {

                            promise.then(function () {

                                setLoginPosition();

                                $(document).on('click', $scope.close);

                                $(window).on('resize', $scope.close);

                                loginControl.show();
                            });

                            return false;
                        });

                        $scope.loginResult = function hideLogin(result) {
                            hide();
                            return $scope.onLogin({
                                result: result || false
                            });
                        };

                        $scope.close = function close() {
                            $scope.$broadcast('clearLogin');
                            $scope.loginResult(false);
                        };
                    }
                };
            }
        ]);

})();